const eyebrow = {
  label: 'Eyebrow',
  name: 'eyebrow',
  component: 'text',
  defaultValue: 'FILTER REPLACEMENT MADE SIMPLE',
};

export default eyebrow;
